// extracted by mini-css-extract-plugin
export default {"advantages__list":"HostCardAdvantagesList_advantages__list__pkHal"};